import { RequiredFields } from './RequiredFields';
import { Divider } from '../../components/Divider';
import { CollapsableContent } from '../../components/CollapsableContent/CollapsableContent';
import { useCreateOperator } from '../../contexts/CreateOperatorContext';
import { availableSettings, CreateOperatorSetting } from './AvailableSettings';
import { CsvImportButton } from './CsvImportButton';
import { useSort } from '../../hooks/useSort';
import { SettingSectionHeader } from './Settings/SettingSectionHeader';
import React from 'react';
import { Footer } from './Footer';
import { SuggestedSettings } from './Settings/SuggestedSettings';
import { Tune } from '@material-ui/icons';

export const Fields = () => {
  const { operator, updateOperator, onSubmit } = useCreateOperator();
  const { sortAsc } = useSort<{ order: number }>('order');

  const settings: CreateOperatorSetting[] = availableSettings({
    values: operator,
  });

  const renderImportButton = (setting: CreateOperatorSetting) => {
    if (
      setting.key !== undefined &&
      setting.canImport &&
      setting.csvColumns !== undefined
    )
      return (
        <CsvImportButton
          settingName={setting.name}
          requiredColumns={setting.csvColumns}
          canOverwrite={setting.canOverwrite}
          onImport={(csv, overwrite) =>
            handleImport(
              setting.onImport !== undefined ? setting.onImport(csv) : [],
              overwrite,
              setting?.key
            )
          }
        />
      );
    return;
  };

  const renderDivider = (index: number) => {
    if (settings.length === index + 1) return;
    return <Divider />;
  };

  const handleImport = (
    csv: any[],
    overwrite: boolean,
    settingKey?: keyof CreateOperator
  ) => {
    let value: any;

    if (settingKey === undefined) return;
    if (overwrite) value = csv;
    else value = [...csv, ...(operator[settingKey] as any[])];
    updateOperator(settingKey, value);
  };

  return (
    <form onSubmit={onSubmit}>
      <RequiredFields />
      <SuggestedSettings />
      <SettingSectionHeader
        header="Optional Configurations"
        description="The settings below are optional and can be created or modified at any
          time after the operator has been created"
        icon={<Tune />}
      />
      {settings
        .filter((setting) => setting.show ?? true)
        .sort(sortAsc)
        .map((setting, index) => (
          <React.Fragment key={`operator-setting-${index + 1}`}>
            <CollapsableContent
              icon={setting.icon}
              count={
                setting.key !== undefined
                  ? ((operator[setting.key] as any[]) ?? []).length
                  : undefined
              }
              customAction={renderImportButton(setting)}
              focus
              header={setting.name}
            >
              {setting.component}
            </CollapsableContent>
            {renderDivider(index)}
          </React.Fragment>
        ))}
      <Footer />
    </form>
  );
};
